import { render, staticRenderFns } from "./CaminhaoImagem.vue?vue&type=template&id=2580bec8&"
import script from "./CaminhaoImagem.vue?vue&type=script&lang=js&"
export * from "./CaminhaoImagem.vue?vue&type=script&lang=js&"
import style0 from "./CaminhaoImagem.vue?vue&type=style&index=0&id=2580bec8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports